/**
 * @ngdoc directive
 * @name phoenix.directive:pxChipsDisableDeleteKey
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to disable the delete/backspace key when the input is blank
 * as the default behavior is to then select a chip and delete it 
 *
 * @usage
 *
 * <md-chips px-chips-disable-delete-key />
 *
 */
export function ChipsDisableDeleteKeyDirective($interval:ng.IIntervalService) {
	return {
		restrict: 'A',
		require: 'mdChips',
		link: function (scope, element, attrs, chipsCtrl) {
			if (!chipsCtrl || chipsCtrl.readonly) { return; }

			// amount of time in MS with which to poll for an input
			var pollingThreshold = 6000; 
			var start = Date.now();
			var timedOut = false;
			var input = null;
			var interval = $interval(function () {
				timedOut = (Date.now() - start) > pollingThreshold;
				input = element.find('input');
				if (input.length === 1) {
					$interval.cancel(interval);
					input[0].addEventListener('keypress', disableDeleteKeys);
					input[0].addEventListener('keydown', disableDeleteKeys);
				}
				else if (timedOut) {
					$interval.cancel(interval);	
				}
			}, 100);

			function disableDeleteKeys(event) {
				if (input.val() === '') {
					//disable hitting the delete/backspace button when there is no value in the input as this starts to delete tags
					var key = event.keyCode || event.charCode;

					if (key === 8 || key === 46) {
						// prevent default behaviour
						event.preventDefault();
						return false;
					}
				}
			}

			scope.$on('$destroy', function () {
				if(input && input.length > 0) {
					input[0].removeEventListener('keypress', disableDeleteKeys);
					input[0].removeEventListener('keydown', disableDeleteKeys);
				}
			});
		}
	};
}

ChipsDisableDeleteKeyDirective.$inject = [
	'$interval'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/chipsDisableDeleteKey/chipsDisableDeleteKey.ts